import { styled } from '@mui/system';
import { MenuItem } from '@mui/material';

export const CustomMenuItem = styled(MenuItem)({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	'.MuiListItemIcon-root': {
		minWidth: '16px',
	},
	'& .MuiListItemText-root': {
		fontSize: '14px',
	},
	height: '20px',
	padding: '8px 16px',
});
